import { createAsyncThunk } from "@reduxjs/toolkit";
import { setDeleteTrackFromLibraryState } from "../slices/librarySlice";
import httpApi from "@src/utils/httpApi";

export const deleteTrackFromLibrary = createAsyncThunk(
  "library/deleteTrackFromLibrary",
  async ({ trackId }: { trackId: string }, { dispatch }) => {
    try {
      dispatch(
        setDeleteTrackFromLibraryState({
          status: "loading",
          loading: true,
          error: null,
        })
      );
      await httpApi.delete(`api/tracks/${trackId}`);
      dispatch(
        setDeleteTrackFromLibraryState({
          status: "succeeded",
          loading: false,
          error: null,
        })
      );
    } catch {
      dispatch(
        setDeleteTrackFromLibraryState({
          status: "failed",
          loading: false,
          error: "Unable to delete track from library",
        })
      );
    }
  }
);
